class PriceRange extends HTMLElement {
	/** @type {HTMLInputElement} */
	minRangeInput;
	/** @type {HTMLInputElement} */
	maxRangeInput;
	/** @type {HTMLInputElement} */
	minPriceInput;
	/** @type {HTMLInputElement} */
	maxPriceInput;

	connectedCallback() {
		this.minRangeInput = this.querySelector('input[type="range"]:first-child');
		this.maxRangeInput = this.querySelector('input[type="range"]:last-child');
		this.minPriceInput = this.querySelector('input[name="filter.v.price.gte"]');
		this.maxPriceInput = this.querySelector('input[name="filter.v.price.lte"]');
		this.minPriceInput.addEventListener("focus", this.minPriceInput.select);
		this.maxPriceInput.addEventListener("focus", this.maxPriceInput.select);
		this.addEventListener("change", this);
		this.addEventListener("input", this);
	}

	disconnectedCallback() {
		this.minPriceInput.removeEventListener("focus", this.minPriceInput.select);
		this.maxPriceInput.removeEventListener("focus", this.maxPriceInput.select);
		this.removeEventListener("change", this);
		this.removeEventListener("input", this);
	}

	handleEvent(event) {
		const { target, type } = event;

		if (type === "change") {
			switch (target) {
				case this.minPriceInput: {
					this.handleInputMinChange(event);

					break;
				}
				case this.maxPriceInput: {
					this.handleInputMaxChange(event);

					break;
				}
				case this.minRangeInput: {
					this.handleRangeMinChange(event);

					break;
				}
				case this.maxRangeInput: {
					this.handleRangeMaxChange(event);

					break;
				}
				// No default
			}
		} else if (type === "input") {
			if (target === this.minRangeInput) {
				this.handleRangeMinInput(event);
			} else if (target === this.maxRangeInput) {
				this.handleRangeMaxInput(event);
			}
		}
	}

	handleInputMinChange(event) {
		event.preventDefault();
		event.target.value = Math.max(
			Math.min(
				Number.parseInt(event.target.value, 10),
				Number.parseInt(this.maxPriceInput.value || event.target.max, 10) - 1,
			),
			event.target.min,
		);
		this.minRangeInput.value = event.target.value;
		this.minRangeInput.parentElement.style.setProperty(
			"--range-min",
			`${(Number.parseInt(this.minRangeInput.value, 10) / Number.parseInt(this.minRangeInput.max, 10)) * 100}%`,
		);
	}

	handleInputMaxChange(event) {
		event.preventDefault();
		event.target.value = Math.min(
			Math.max(
				Number.parseInt(event.target.value, 10),
				Number.parseInt(this.minPriceInput.value || event.target.min, 10) + 1,
			),
			event.target.max,
		);
		this.maxRangeInput.value = event.target.value;
		this.maxRangeInput.parentElement.style.setProperty(
			"--range-max",
			`${(Number.parseInt(this.maxRangeInput.value, 10) / Number.parseInt(this.maxRangeInput.max, 10)) * 100}%`,
		);
	}

	handleRangeMinChange(event) {
		event.stopPropagation();
		this.minPriceInput.value = event.target.value;
		this.minPriceInput.dispatchEvent(new Event("change", { bubbles: true }));
	}

	handleRangeMaxChange(event) {
		event.stopPropagation();
		this.maxPriceInput.value = event.target.value;
		this.maxPriceInput.dispatchEvent(new Event("change", { bubbles: true }));
	}

	handleRangeMinInput(event) {
		event.target.value = Math.min(
			Number.parseInt(event.target.value, 10),
			Number.parseInt(this.maxPriceInput.value || event.target.max, 10) - 1,
		);
		event.target.parentElement.style.setProperty(
			"--range-min",
			`${(Number.parseInt(event.target.value, 10) / Number.parseInt(event.target.max, 10)) * 100}%`,
		);
		this.minPriceInput.value = event.target.value;
	}

	handleRangeMaxInput(event) {
		event.target.value = Math.max(
			Number.parseInt(event.target.value, 10),
			Number.parseInt(this.minPriceInput.value || event.target.min, 10) + 1,
		);
		event.target.parentElement.style.setProperty(
			"--range-max",
			`${(Number.parseInt(event.target.value, 10) / Number.parseInt(event.target.max, 10)) * 100}%`,
		);
		this.maxPriceInput.value = event.target.value;
	}
}
customElements.define("price-range", PriceRange);
